module.exports = __webpack_public_path__ + "static/animation-aviva-cover-c38e0db67cb30d2986c98a472e1d5670.png";